import { UiOption } from '@/lib/helpers';
import { startCase } from 'lodash';

export enum McpToolClassificationAction {
  READ = 'read',
  WRITE = 'write',
}

export type McpToolClassification = {
  action: McpToolClassificationAction;
};

export const getMcpToolActionOptions = (): UiOption[] => {
  return Object.values(McpToolClassificationAction).map((value) => ({
    label: startCase(value),
    value: value,
  }));
};
